import { formatDate, joinParts, safeUrl, truncate } from '../../../../format'

import style from './style.module.css'

const NewsItem = ({ news }) => {
  const href = safeUrl(news.url)
  // truncate keeps a runaway summary out of the DOM; the two-line clamp in CSS
  // does the visual trimming, so no ellipsis is baked into the layout.
  const summary = truncate(news.summary, 90)
  const meta = joinParts([news.publisher, formatDate(news.publishedAt)])

  const body = (
    <>
      {news.title && <span className={style.companyModal_news_item_title}>{news.title}</span>}
      {summary && <span className={style.companyModal_news_item_text}>{summary}</span>}
      {meta && <span className={style.companyModal_news_item_date}>{meta}</span>}
    </>
  )

  if (!href) {
    return <div className={style.companyModal_news_item}>{body}</div>
  }

  return (
    <a
      className={`${style.companyModal_news_item} ${style.companyModal_news_item_link}`}
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-log-action="spotlight_open_news"
    >
      {body}
    </a>
  )
}

export default NewsItem
